export default __webpack_public_path__ + "static/media/mini_qp.f1834af6.png";